import React, { useState, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });
  const [source, setSource] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    }),
  );
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  useEffect(() => {
    // Captura os parâmetros da URL para definir a origem (source)
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");
    if (utmSource) {
      setSource(utmSource);
    }
    // Adiciona um listener para verificar a validade do formulário sempre que 'forms' mudar
    setIsFormValid(validator.allValid());
  }, [forms, validator]);

  const submitHandler = (e) => {
    if (validator.allValid()) {
      validator.hideMessages();
      // Permite o envio padrão do formulário
      setIsSubmitting(true); // Atualiza o estado do botão
      return true;
    } else {
      e.preventDefault(); // Impede o envio se a validação falhar
      validator.showMessages();
      toast.error("Por favor, preencha os campos corretamente.");
      return false;
    }
  };

  return (
    <form
      action="https://paginas.rocks/capture"
      method="post"
      onSubmit={submitHandler}
      className="contact-validation-active"
    >
      {/* Campos ocultos necessários para a Leadlovers */}
      <input id="id" name="id" type="hidden" value="766491" />
      <input id="mid" name="mid" type="hidden" value="766491" />
      <input id="pid" name="pid" type="hidden" value="22012045" />
      <input id="list_id" name="list_id" type="hidden" value="766491" />
      <input id="provider" name="provider" type="hidden" value="leadlovers" />
      {/* Campo oculto para a origem do lead */}
      <input id="source" name="source" type="hidden" value={source} />

      <div className="form-fields">
        <div className="form-field">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              nid="name"
              name="name"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Seu nome"
            />
            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>
        <div className="form-field">
          <input
            value={forms.email}
            type="email"
            id="email"
            name="email"
            onBlur={(e) => changeHandler(e)}
            onChange={(e) => changeHandler(e)}
            placeholder="Seu melhor e-mail"
          />
          {validator.message("email", forms.email, "required|email")}
        </div>
        <div className="form-field">
          <input
            value={forms.phone}
            type="phone"
            id="phone"
            name="phone"
            onBlur={(e) => changeHandler(e)}
            onChange={(e) => changeHandler(e)}
            placeholder="WhatsApp"
          />
          {validator.message("phone", forms.phone, "required|phone")}
        </div>
      </div>
      <div className="submit-area button-submit">
        <button
          type="submit"
          className="theme-btn"
          disabled={!isFormValid || isSubmitting}
        >
          {isSubmitting ? "ENVIANDO..." : "QUERO GARANTIR MEU KIT"}
        </button>
      </div>
      {/* Imagem de rastreamento da Leadlovers */}
      <img
        src="https://llimages.com/redirect/redirect.aspx?A=V&p=22012045&m=766491"
        style={{ display: "none" }}
        alt="LeadLovers"
      />
    </form>
  );
};

export default ContactForm;
